import React from 'react';
import {
  Typography,
  Container,
  Box,
  Card,
  Chip,
} from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

function Ventures() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />

      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0F172A 0%, #111827 50%, #1E293B 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '-30%',
            right: '-15%',
            width: '400px',
            height: '400px',
            background: 'radial-gradient(circle, rgba(126, 181, 216, 0.07) 0%, transparent 70%)',
            borderRadius: '50%',
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Typography
            variant="h2"
            component="h1"
            sx={{
              fontWeight: 800,
              textAlign: 'center',
              color: 'white',
              mb: 3,
              fontSize: { xs: '2.5rem', md: '3.5rem' },
            }}
          >
            Our Ventures
          </Typography>
          <Typography
            variant="h6"
            sx={{
              textAlign: 'center',
              color: 'rgba(255,255,255,0.75)',
              maxWidth: 700,
              mx: 'auto',
              fontWeight: 400,
              lineHeight: 1.7,
            }}
          >
            Beyond consulting, Actuation also engages in private ventures of its own.
            We invest our expertise and resources into building products to solve
            real-world problems.
          </Typography>
        </Container>
      </Box>

      {/* Ayon Card */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
        <Card
          elevation={0}
          sx={{
            mb: 4,
            p: { xs: 3, sm: 5 },
            background: '#ffffff',
            border: '1px solid',
            borderColor: 'divider',
            borderLeft: '6px solid #2C5282',
            borderRadius: 2,
            transition: 'all 0.3s ease',
            '&:hover': {
              boxShadow: '0 8px 32px rgba(0,0,0,0.09)',
            },
          }}
        >
          <Box>
            {/* Content */}
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 1 }}>
                <Box
                  component="img"
                  src="/Ayon-icon.png"
                  alt="Ayon logo"
                  sx={{
                    width: { xs: 80, sm: 100 },
                    height: { xs: 80, sm: 100 },
                    objectFit: 'contain',
                    borderRadius: 2,
                    flexShrink: 0,
                  }}
                />
                <Typography
                  variant="h4"
                  component="h2"
                  sx={{ fontWeight: 800, color: 'text.primary', lineHeight: 1.2 }}
                >
                  Ayon
                </Typography>
                <Chip
                  label="In Development"
                  size="small"
                  sx={{
                    bgcolor: 'rgba(74, 127, 193, 0.1)',
                    color: '#2C5282',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                  }}
                />
              </Box>

              <Typography
                variant="subtitle1"
                sx={{ color: '#4A7FC1', fontWeight: 600, mb: 2 }}
              >
                Your personal AI health coach
              </Typography>

              <Typography
                variant="body1"
                sx={{ color: 'text.secondary', lineHeight: 1.8, mb: 3, maxWidth: 680 }}
              >
                Ayon is a smart wearable companion that guides your fitness, nutrition,
                and mental wellbeing. It observes your workouts and corrects your form in
                real time, leads guided breathing and meditation sessions, and continuously
                tracks biometrics like sleep, hydration, and blood pressure — coaching you
                towards a stronger, more balanced lifestyle, anytime, anywhere.
              </Typography>

            </Box>
          </Box>
        </Card>

        {/* Mika Card */}
        <Card
          elevation={0}
          sx={{
            p: { xs: 3, sm: 5 },
            background: '#ffffff',
            border: '1px solid',
            borderColor: 'divider',
            borderLeft: '6px solid #2C5282',
            borderRadius: 2,
            transition: 'all 0.3s ease',
            '&:hover': {
              boxShadow: '0 8px 32px rgba(0,0,0,0.09)',
            },
          }}
        >
          <Box>
            {/* Content */}
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 1 }}>
                <Box
                  component="img"
                  src="/Mika-icon.png"
                  alt="Mika logo"
                  sx={{
                    width: { xs: 80, sm: 100 },
                    height: { xs: 80, sm: 100 },
                    objectFit: 'contain',
                    flexShrink: 0,
                  }}
                />
                <Typography
                  variant="h4"
                  component="h2"
                  sx={{ fontWeight: 800, color: 'text.primary', lineHeight: 1.2 }}
                >
                  Mika
                </Typography>
                <Chip
                  label="In Development"
                  size="small"
                  sx={{
                    bgcolor: 'rgba(74, 127, 193, 0.1)',
                    color: '#2C5282',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                  }}
                />
              </Box>

              <Typography
                variant="subtitle1"
                sx={{ color: '#4A7FC1', fontWeight: 600, mb: 2 }}
              >
                Real-time travel companion
              </Typography>

              <Typography
                variant="body1"
                sx={{ color: 'text.secondary', lineHeight: 1.8, mb: 3, maxWidth: 680 }}
              >
                Mika is a mobile app built for travellers who want to communicate naturally
                across language barriers — in real time. Whether you're navigating a market
                in Tokyo, ordering dinner in Lisbon, or asking for directions in Bangkok, Mika
                listens, translates, and speaks for you instantly, so language never stands
                between you and the experience.
              </Typography>

            </Box>
          </Box>
        </Card>

        {/* Coming Soon */}
        <Card
          elevation={0}
          sx={{
            mt: 4,
            p: { xs: 4, sm: 5 },
            textAlign: 'center',
            background: '#ffffff',
            border: '2px dashed',
            borderColor: 'divider',
            borderRadius: 3,
          }}
        >
          <RocketLaunchIcon
            sx={{
              fontSize: 48,
              color: '#4A7FC1',
              mb: 2,
              opacity: 0.7,
            }}
          />
          <Typography
            variant="h5"
            component="h3"
            sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}
          >
            More Coming Soon
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
            We're working on more exciting ventures. Check back soon for updates on our latest projects.
          </Typography>
        </Card>
      </Container>

      <Footer />
    </Box>
  );
}

export default Ventures;
